// src/lib/intake/askedFacts.js
//
// Ticket 066 (Advisor Intake I6). The allow-list of facts the intake actually
// asks, keyed by screen id. Review lists a gap only for these; the server's
// `open_facts` also holds facts the intake never asks or only derives
// (resident_self_report, retirement_withdrawal_type, per-item tax_withheld_spain,
// derived sale_location and owns_*_property), and those are never gaps.
//
// Defined ONCE here (intakeConfig re-exports it). Dependency free on purpose: the
// Deno parity test (supabase/functions/_shared/intake/__tests__/reviewParity.test.ts)
// imports this file directly. Keys are `<domain>.<fact>`; a trailing `.*` matches
// every fact under that prefix.
//
// Screen 1.1 (tax year) has no fact. 2.3 and 2.3s both carry the spouse count
// because which one is open depends on the spouse gate. 3.3 is listed even though
// the browser derives the sale location when a sale card fixes the country.

export const INTAKE_ASKED_FACTS = {
  '1.2': ['household.move_date'],
  '1.1': [],
  '1.3': ['household.comunidad_autonoma'],
  '1.4': ['household.citizenship_status', 'household.eu_citizen'],
  '1.5': ['household.marital_status', 'household.asset_split', 'household.spouse_citizenship_status', 'household.spouse_eu_citizen'],
  '1.6': ['household.age_band', 'household.spouse_age_band'],
  '1.7': ['household.children_under_25', 'household.children_under_3', 'household.ascendants_over_65', 'household.ascendants_over_75', 'household.disability_taxpayer'],
  '5.1': ['filing_history.filed_spain_before', 'filing_history.has_gestor'],
  '2.1': [
    'events.worked_for_employer', 'events.self_employed', 'events.owned_business',
    'events.received_rental_income', 'events.sold_property',
    'events.received_dividends_interest', 'events.large_investment_sale', 'events.sold_crypto',
    'events.rsu_or_options', 'events.received_pension_income', 'events.retirement_withdrawal',
    'events.inheritance_or_gift', 'events.made_significant_gift',
    'property.foreign_property_countries',
  ],
  '2.2': ['income.self_income_items'],
  '2.3': ['income.spouse_income_items'],
  '2.3s': ['income.spouse_income_items'],
  // The two contribution bases are never asked (the server computes them), so they
  // stay unanswered; they must not count as gaps (ticket 069 fix).
  '2.4': ['income.autonomo.autonomo_type', 'income.autonomo.registered_reta_last_2_years', 'income.autonomo.previously_used_tarifa_plana'],
  '2.5': ['household.beckham_status'],
  '3.3': ['property.sale_location'],
  '4.1': ['assets.worldwide_net_worth_band', 'assets.foreign_account_band'],
}

function matches(pattern, key) {
  return pattern.endsWith('.*') ? key.startsWith(pattern.slice(0, -1)) : pattern === key
}

// Is `domain.fact` asked by the intake on ANY screen? Returns the screens that ask it.
export function screensAsking(key) {
  return Object.keys(INTAKE_ASKED_FACTS).filter((id) => INTAKE_ASKED_FACTS[id].some((p) => matches(p, key)))
}
